import React from "react";

import Presentation from "./presentation";

const component = ( props, ref ) => {
	return (
		<Presentation
			{ ...props }
			ref       = { ref }
		/>
	);
};

export default React.forwardRef ( component );